import { Icon } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";

import { useAffiliateButtonAction } from "~/components/blocks/product/common/blocks/product-title/action-buttons/affiliate/use-affiliate-button-action";
import { useMatchMedia } from "~/hooks/use-match-media";

/** アフィリエイトボタンコンポーネント */
export const AffiliateButton = () => {
  const { openAffiliateModal, viewableAffiliate } = useAffiliateButtonAction();
  const { isSpSize } = useMatchMedia();
  if (!viewableAffiliate) return null;

  const iconSize = isSpSize ? "L" : "XL";
  return (
    <>
      <Styled.DivButtonAffiliate aria-label="アフィリエイトボタン">
        <Styled.DivAffiliateButton
          role="button"
          tabIndex={0}
          onKeyDown={openAffiliateModal}
          onClick={openAffiliateModal}
        >
          <Styled.ImageLeft src="/images/appIcon_dmm_affiliate.png" />
          <Styled.SpanText>リンクを作成</Styled.SpanText>
          <Icon name="arrowRight" color="GRAY50" size={iconSize} />
        </Styled.DivAffiliateButton>
      </Styled.DivButtonAffiliate>
    </>
  );
};
